import React from 'react';
import FloatingLabelInputLayout from './FLInputLayout';
import { TextAreaLayoutProps, TextAreaLayoutType } from 'framework/form';

const FLTextAreaLayout: TextAreaLayoutType = (props: TextAreaLayoutProps) => {
  const { numberOfRows, ...restProps } = props;

  return <FloatingLabelInputLayout {...restProps} multiline rows={numberOfRows ?? undefined} />;
};

export default FLTextAreaLayout;
